import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';

const apiServer = environment.apiServer;
declare var $: any;

@Component({
  selector: 'app-other-kp-modal-mail-sender',
  templateUrl: './modal-mail-sender.component.html',
  styleUrls: ['./modal-mail-sender.component.sass']
})
export class ModalOtherKpMailSenderComponent implements OnInit {
  http: HttpClient;
  spinner: NgxSpinnerService;
  sanitizer: DomSanitizer;
  private isVisible: boolean = false;
  mail = {participant:undefined, idAuction:undefined, mailTo:undefined, mailCopy:undefined, mailTopic:undefined,  mailBody:undefined};

  returnValue: any

  constructor(private _http: HttpClient, private _spinner: NgxSpinnerService, private _sanitizer: DomSanitizer) {
    this.http = _http;
    this.spinner = _spinner;
    this.sanitizer = _sanitizer
   }

  ngOnInit() {
    $('#modalMailSender').on('show.bs.modal', function () {
      $('#modalAuctionDetail').css({'z-index': 1030});
    })

    $('#modalMailSender').on('hidden.bs.modal', function () {
      $('#modalAuctionDetail').css({'z-index': 1041});
    })
  }

  onSave(){
    if($("#myform").find('.form-control:invalid').length !== 0){
      console.log("invalid!");
    }
    else{
      this.sendEmail();
    }
  }

  public sendEmail() {
    this.http.post<string>(apiServer + "/otherKp/SendEmail", this.mail).subscribe(resp => {
      this.returnValue.value = this.sanitizer.bypassSecurityTrustHtml(resp)
      setTimeout(() => {
        this.returnValue.value = ""
      }, 5000)
    });
  }
  
  public mailToCommercialOffer(code, distributerParticipant, returnedValue){
    //$('#modalMailSender').modal('toggle');
    this.spinner.show();

    this.http.get<Array<string>>(apiServer + "/otherKp/"+ code + "/" + distributerParticipant + "/" + 0)
    .subscribe(resp => { 
      this.spinner.hide();
      this.mail.participant = distributerParticipant;
      this.mail.idAuction = code;
      this.mail.mailTo = resp["mailTo"];
      if(resp["mailFrom"] != null){
        this.mail.mailCopy = resp["mailFrom"];
      }else{
        this.mail.mailCopy = " ";
      }
      this.mail.mailTopic = resp["mailTopic"];
      this.mail.mailBody = resp["mailBody"];
    });

    this.returnValue = returnedValue
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/component/other-kp-detail/modal-mail-sender/modal-mail-sender.component.ts